import React, { useEffect } from "react";
import axios from "axios";
import history from "./history";
import Cookies from "js-cookie";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("errrrrr=" + error.message);
    if (error.response.status === 401) {
      history.push("/");
      Cookies.set("houna-accesstoken", null);
    } else {
      return Promise.reject(error);
    }
  }
);
axios.defaults.proxy = process.env.REACT_APP_BASE_URL;
instance.interceptors.request.use((config) => {
  config.headers.token = `${Cookies.get("houna-accesstoken")}`;
  return config;
});

export default instance;
